import React from 'react';
import { render } from 'react-dom';
import {parseDataToProps} from "../../../helpers";

const compareCountNodes = document.querySelectorAll('.compare-count');

if (compareCountNodes.length > 0) {
    import(/* webpackChunkName: "CompareCount" */ './components/CompareCount').then(({ObservingCompare: ObservingCompare}) => {
        [...compareCountNodes].forEach((node) => render(
            <ObservingCompare {...parseDataToProps(node.dataset)} />, node));
    });
}
